import { useSearchParams } from 'react-router-dom'
import SubHeaders from '@/components/Headers/SubHeaders'
import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import { Tabs } from 'vnetwork-ui'
import { paths } from '@/utils/path'
import AddIcons from '@/icons/AddIcons'
import { Server, Cpu } from 'lucide-react'
import { useModelList } from '../../hooks/use-model-list'

const itemTypeTabs = [
    {
        label: 'EQUIPMENT',
        value: 'equipment',
        startIcon: <Server className="w-4 h-4" />,
    },
    {
        label: 'COMPONENT',
        value: 'component',
        startIcon: <Cpu className="w-4 h-4" />,
    },
]

const ModelsList = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const selectedType =
        (searchParams.get('tab') as 'equipment' | 'component') || 'equipment'

    const handleTypeChange = (newType: string) => {
        setSearchParams({ tab: newType })
    }

    const {
        models,
        pagination,
        stateComponent,
        control,
        setFilter,
        params,
        searchInputProps,
        columns,
        filterItems,
        filterToggles,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        handleCreate,
    } = useModelList(selectedType)

    return (
        <>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.warehouse,
                        title: 'Capacities & Resources',
                    },
                    {
                        path: paths.warehouseModels,
                        title: 'Item Models',
                    },
                ]}
                actions={[
                    {
                        icon: <AddIcons />,
                        label: 'New Model',
                        onClick: handleCreate,
                    },
                ]}
            />

            <Tabs
                tabs={itemTypeTabs}
                activeTab={selectedType}
                onChangeTab={handleTypeChange}
                color="info"
                className="!px-2"
            />

            <Paper className="mt-2 space-y-2">
                <FilterBar
                    storageKey={`warehouse-models-${selectedType}`}
                    control={control}
                    setFilter={setFilter}
                    items={filterItems}
                />

                {stateComponent || (
                    <DataTableCustomized
                        columns={columns}
                        rows={models}
                        rowKey={(row) => row.id}
                        size="small"
                        toolbar={{
                            search: {
                                ...searchInputProps,
                                placeholder: 'Search models...',
                            },
                            settings: {
                                show: true,
                                storageKey: `warehouse-models-${selectedType}`,
                                filterToggles,
                            },
                        }}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={{
                            page: params.page,
                            pageSize: params.page_size,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                        }}
                    />
                )}
            </Paper>
        </>
    )
}

export default ModelsList
